<div class="row" *ngIf="widgetType">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="widget.name">
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="widget.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Wind Segment Size</label>
      <input type="number" class="form-control" [(ngModel)]="widget.windSegmentSize" min="1" max="20">
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group input-group-sm">
      <label>Wind Speed</label>
      <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="primaryActive" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
      <!--<app-time-series-select [timeSeriesDetail]="primaryActive" [enableTagMatch]="true" (uriChange)="selectedInput($event, 0)"></app-time-series-select>-->
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group input-group-sm">
      <label>Wind Direction</label>
      <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="secondaryActive" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
      <!--<app-time-series-select [timeSeriesDetail]="secondaryActive" [enableTagMatch]="true" (uriChange)="selectedInput($event, 1)"></app-time-series-select>-->
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">      
      <label>Show Legend</label>
      <div>
        <input type="checkbox" [(ngModel)]="widget.showLegend"/>
      </div>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group input-group-sm">      
      <label>Show Title</label>
      <div>
        <input type="checkbox" [(ngModel)]="widget.showTitle"/>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">      
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="form-select">
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
      </select>
    </div>
  </div>
</div>